import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { 
  Box, 
  TextField, 
  Button, 
  Typography, 
  CircularProgress,
  Paper
} from '@mui/material';
import { db, auth } from '../firebase';
import { doc, getDoc, addDoc, collection, serverTimestamp } from 'firebase/firestore';

const AddHighlight = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [book, setBook] = useState(null);
  const [highlight, setHighlight] = useState('');
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    const fetchBook = async () => {
      try {
        const bookId = new URLSearchParams(location.search).get('bookId');
        if (!bookId) {
          navigate('/');
          return;
        }

        const bookDoc = await getDoc(doc(db, 'books', bookId));
        if (!bookDoc.exists()) {
          navigate('/');
          return;
        }

        setBook({ id: bookDoc.id, ...bookDoc.data() });
      } catch (error) {
        console.error('책 정보 불러오기 오류:', error);
        navigate('/');
      } finally {
        setLoading(false);
      }
    };

    fetchBook();
  }, [location.search, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!highlight.trim()) return;

    setSaving(true);
    try {
      const userId = auth.currentUser?.uid;
      if (!userId) {
        alert('로그인이 필요합니다.');
        return;
      }

      await addDoc(collection(db, 'highlights'), {
        bookId: book.id,
        userId,
        text: highlight.trim(),
        createdAt: serverTimestamp(),
        updatedAt: serverTimestamp()
      });

      navigate(`/book/${book.id}`);
    } catch (error) {
      console.error('하이라이트 저장 오류:', error);
      alert('하이라이트 저장에 실패했습니다.');
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!book) {
    return null;
  }

  return (
    <Box sx={{ p: 3, maxWidth: '600px', margin: '0 auto' }}>
      <Paper sx={{ p: 3, mb: 3 }}>
        <Typography variant="h6" gutterBottom>
          {book.title}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {book.authors}
        </Typography>
      </Paper>

      <form onSubmit={handleSubmit}>
        <TextField
          fullWidth
          multiline
          rows={4}
          label="하이라이트 내용"
          value={highlight}
          onChange={(e) => setHighlight(e.target.value)}
          margin="normal"
          required
        />
        <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end' }}>
          <Button
            type="submit"
            variant="contained"
            disabled={saving}
          >
            {saving ? '저장 중...' : '저장'}
          </Button>
        </Box>
      </form>
    </Box>
  );
};

export default AddHighlight; 